module.exports = __webpack_public_path__ + "static/step2-6e28b5a8a68f363dde4408776bf6fc5d.png";